import React, { useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { useAppSelector } from 'store';
import { selectRecaptchaKey } from "../../../store/payments";
import { selectCurrentLanguage } from "../../../store/locale";

type Props = {
  setValue: UseFormSetValue<FieldValues>;
};

export const Recaptcha = React.forwardRef<any, Props>(({ setValue }, ref) => {
  const key = useAppSelector(selectRecaptchaKey);
  const lang = useAppSelector(selectCurrentLanguage);

  const [recaptchaKey, setRecaptchaKey] = React.useState(0);
  const [captchaLanguage, setCaptchaLanguage] = React.useState(lang);

  useEffect(() => {
    // https://developers.google.com/recaptcha/docs/language
    setCaptchaLanguage(() => (lang === 'cz' ? 'cs' : lang));
    setRecaptchaKey(prevKey => prevKey + 1);
    (ref as any).current.reset();
  }, [lang]);

  const onChange = (value: string) => {
    setValue('captcha', value);
  };

  return (
    <ReCAPTCHA
      ref={ref}
      key={recaptchaKey}
      hl={captchaLanguage}
      sitekey={key}
      onChange={onChange}
    />
  );
});
